//Changed name of this file from AuthContext.jsx to AuthProvider.jsx

import React, { createContext, useState, useContext, useEffect} from 'react';
import { axiosInstance } from '../../lib/axiosInstance';
//import { useNavigate } from 'react-router-dom';    //Can't use it here. Can only be used in the context of a router.


const AuthContext = createContext();    //Creating a global state for authentication status.


//Use the context provider to wrap your application so that the authentication state is available to all components.
//AuthProvider is a component. It's basically SharedStateProvider.
export const AuthProvider = ({ children }) => {
  //const navigate = useNavigate();
  //const [auth, setAuth] = useState(false); // Initially not authenticated
  const [isAuthenticated, setIsAuthenticated] = useState('loading');

  //The useEffect hook in the AuthProvider component is used to synchronize the authentication state (isAuthenticated) 
  //with localStorage.

  //This hook runs side effects in functional components. It takes two arguments: a function to run the side effect and a 
  //dependency array to control when the effect runs.

  //The purpose of the below useEffect is to initialize the isAuthenticated state from localStorage when the component mounts. 
  //This ensures that the user's authentication state is preserved across page refreshes or reopening the browser.
  
  useEffect(() => {
    const authorise = async()=>{
      try{
        //const response = await axiosInstance.get('/auth/authorise');
        await axiosInstance.get('/auth/authorize');
        setIsAuthenticated('authenticated');
        //console.log("/auth/authorise response.data : "+response.data);

      }catch(error){
        //setIsAuthenticated('unauthenticated'); 

        // Handle error
        if (error.response && error.response.status === 403) {
          console.error("Error 403: Forbidden. The user email ID is not verified.");
          setIsAuthenticated('email-unverified'); // You could use this state to display a forbidden message
          //console.log("isAuthenticated :"+isAuthenticated);
        } else {
          console.error("An error occurred during authorization.", error);
          setIsAuthenticated('unauthenticated'); // Any other error leads to unauthenticated
          //console.log("isAuthenticated :"+isAuthenticated);
        }
      }
    } 
    authorise();
  }, []);       //isAuthenticated   //The empty array [] means this useEffect will run only once, when the component mounts.

  

  return (     //isAuthenticated and token are states. And login and logout are functions.
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated}}>
      {children}
    </AuthContext.Provider>
  );
};

//useAuth is a function I guess.
export const useAuth = () => {
  return useContext(AuthContext);
};
